import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';
import { getLastSaleOrderDaybook } from '../redux/actions/salesOrder';

const useSalesOrderLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastSaleDaybook = useSelector((state) => state.salesOrder.lastSaleDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastSaleDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && financialYear?.financial_year) {
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const params = {
            companyId: user.loginhistory.companyId,
            fromDate,
            toDate,
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastSaleOrderDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastSaleDaybook();
   }, [getLastSaleDaybook]);

   return {
      lastSaleDaybook,
      setSelectedDaybookId,
   };
};

export default useSalesOrderLastDaybook;
